import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import '../../css/Plans.css';

export default function Plans({ isNavOpen }) {
  const { t } = useTranslation();

  const plans = [
    {
      subscription_name: t('Plans.plan.name1'),
      subscription_purpose: t('Plans.plan.purpose1'),
      price: 0.0,
      number_of_levels: 3,
      storage_mb: 100,
      number_of_users: 10,
      addons: [],
    },
    {
      subscription_name: t('Plans.plan.name2'),
      subscription_purpose: t('Plans.plan.purpose2'),
      price: 49.0,
      number_of_levels: 5,
      storage_mb: 500,
      number_of_users: 50,
      addons: [],
    },
    {
      subscription_name: t('Plans.plan.name3'),
      subscription_purpose: t('Plans.plan.purpose3'),
      price: 159.0,
      number_of_levels: 20,
      storage_mb: 2048,
      number_of_users: 300,
      isPopular: true,
      addons: [
        t('Plans.plan.addon1'),
        t('Plans.plan.addon2'),
        t('Plans.plan.addon3'),
      ],
    },
    {
      subscription_name: t('Plans.plan.name4'),
      subscription_purpose: t('Plans.plan.purpose4'),
      price: null,
      isCustom: true,
      number_of_levels: t('Plans.plan.name4'),
      storage_mb: t('Plans.plan.name4'),
      number_of_users: t('Plans.plan.name4'),
      addons: [],
    },
  ];

  function formatStorage(mb) {
    if (typeof mb !== 'number') return mb;

    return mb >= 1024
      ? `${(mb / 1024).toFixed(1)} GB`
      : `${mb} MB`;
  }

  return (
    <div className={isNavOpen ? 'body-squeezed' : 'body'}>
      <div className="plans-container">
        <h2 className="plans-title">{t('Plans.title')}</h2>

        <p className="plans-subtitle">
          {t('Plans.subtitle')}
        </p>

        <section className="plans-hero">
          <p className="plans-eyebrow">{t('Plans.hero.eyebrow')}</p>

          <h2 className="plans-title">
            {t('Plans.hero.title')}
          </h2>

          <p className="plans-subtitle">
            {t('Plans.hero.subtitle')}
          </p>
        </section>

        <section className="plans-problems">
          <h3>{t('Plans.problems.title')}</h3>

          <div className="plans-problems-grid">
            <div>{t('Plans.problems.problem1')}</div>
            <div>{t('Plans.problems.problem2')}</div>
            <div>{t('Plans.problems.problem3')}</div>
            <div>{t('Plans.problems.problem4')}</div>
          </div>
        </section>

        <div className="plans-grid">
          {plans.map((plan, idx) => (
            <div
              key={idx}
              className={`plan-card ${plan.isPopular ? 'plan-card-popular' : ''}`}
            >
              {plan.isPopular && (
                <div className="plan-badge">
                  {t('Plans.bestValue')}
                </div>
              )}

              <h3>{plan.subscription_name}</h3>

              <p className="plan-purpose">
                {plan.subscription_purpose}
              </p>

              <div className="plan-price">
                {plan.isCustom
                  ? t('Plans.plan.name4')
                  : plan.price === 0
                    ? t('Plans.free')
                    : `CAD $${plan.price.toFixed(2)} / ${t('Plans.month')}`}
              </div>

              {!plan.isCustom && plan.price !== 0 && (
                <p className="plan-billing">
                  {t('Plans.billedInCad')}
                </p>
              )}

              <ul className="plan-features">
                <li><strong>{t('Plans.levels')}:</strong> {plan.number_of_levels}</li>
                <li><strong>{t('Plans.storage')}:</strong> {formatStorage(plan.storage_mb)}</li>
                <li><strong>{t('Plans.users')}:</strong> {plan.number_of_users}</li>

                {plan.addons.length > 0 && (
                  <>
                    <strong className="addons-title">{t('Plans.addons')}:</strong>
                    <ul className="addons-list">
                      {plan.addons.map((addon, i) => (
                        <li key={i}>{addon}</li>
                      ))}
                    </ul>
                  </>
                )}
              </ul>

              <div className="plans-get-started-container">
                {plan.isCustom ? (
                  <a
                    href="mailto:contact@dnzify.com"
                    className="get-started-button"
                  >
                    {t('Plans.contactUs')}
                  </a>
                ) : (
                  <Link to="/start" className="get-started-button">
                    {t('Home.navbar.getStarted')}
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>


        <section className="plans-founder-offer">
          <h3>{t('Plans.founderOffer.title')}</h3>

          <p>{t('Plans.founderOffer.text')}</p>

          <Link to="/start" className="get-started-button">
            {t('Plans.founderOffer.cta')}
          </Link>
        </section>

      </div>
    </div>
  );
}